import { InjectionToken } from '@angular/core';

import type { BeforeunloadMessageType } from './beforeunload.service';

export const BEFORE_UNLOAD_MESSAGE =
  new InjectionToken<BeforeunloadMessageType>('BEFORE_UNLOAD_MESSAGE');
export const BEFORE_UNLOAD_FN = new InjectionToken('BEFORE_UNLOAD_FN');
